const FONT_CACHE = new Set<string>();

export const loadFont = async (fontFamily: string) => {
  try {
    // Normalize the font family name
    const normalizedFontFamily = fontFamily
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
    
    // Skip if already loaded
    const cacheKey = `aimdoc-font-${normalizedFontFamily}`;
    if (FONT_CACHE.has(cacheKey)) return;

    // Add preconnect links if needed
    if (!document.querySelector('link[href="https://fonts.googleapis.com"]')) {
      const preconnect1 = document.createElement('link');
      preconnect1.rel = 'preconnect';
      preconnect1.href = 'https://fonts.googleapis.com';
      
      const preconnect2 = document.createElement('link');
      preconnect2.rel = 'preconnect';
      preconnect2.href = 'https://fonts.gstatic.com';
      preconnect2.crossOrigin = 'anonymous';
      
      document.head.appendChild(preconnect1);
      document.head.appendChild(preconnect2);
    }

    // Match exact URL formats from original
    const fontUrls: Record<string, string> = {
      'Poppins': 'family=Poppins:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400;1,500;1,600',
      'Open Sans': 'family=Open+Sans:ital,wght@0,300..600;1,300..600',
      'Roboto': 'family=Roboto:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400;1,500;1,600',
      'Lato': 'family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700',
      'Montserrat': 'family=Montserrat:ital,wght@0,300..600;1,300..600'
    };

    // Load font with exact URL format
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `https://fonts.googleapis.com/css2?${fontUrls[normalizedFontFamily]}&display=swap`;
    
    await new Promise((resolve, reject) => {
      link.onload = resolve;
      link.onerror = reject;
      document.head.appendChild(link);
    });

    FONT_CACHE.add(cacheKey);
    
  } catch (error) {
    console.error('Font loading failed:', error);
    throw error;
  }
};